const userConstants = {
  USER_TOKEN: 'USER_TOKEN_GASTOS_BACKOOFFICE',
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  LOGOUT: 'USERS_LOGOUT',

  USER_ACCOUNT: 'USER_ACCOUNT',
  USER_ACCOUNT_REQUEST: 'USER_ACCOUNT_REQUEST',
  USER_ACCOUNT_SUCCESS: 'USER_ACCOUNT_SUCCESS',
  USER_ACCOUNT_FAILURE: 'USER_ACCOUNT_FAILURE',
  USER_ACCOUNT_REMOVE: 'USER_ACCOUNT_REMOVE',
  USER_ACCOUNT_PROFILE_ID: 'USER_ACCOUNT_PROFILE_ID',
  SELECTED_CURRENT_MENU_ID: 'SELECTED_CURRENT_MENU_ID',

  FILTER_CONTABILIDAD: 'FILTER_CONTABILIDAD',
  FILTER_CECO: 'FILTER_CECO',
  FILTER_CAJA: 'FILTER_CAJA',
  FILTER_ADMIN: 'FILTER_ADMIN',
  
  FILTER_RENDICION: 'FILTER_RENDICION',
  FILTER_APERTURA_CAJA: 'FILTER_APERTURA_CAJA',
  FILTER_ADELANTO_OPERATION: 'FILTER_ADELANTO_OPERATION',
  FILTER_DEVOLUCION_OPERATION: 'FILTER_DEVOLUCION_OPERATION',
  FILTER_ADELANTO_CASH: 'FILTER_ADELANTO_CASH',
  FILTER_DEVOLUCION_CASH: 'FILTER_DEVOLUCION_CASH',
  FILTER_ARQUEO_CAJA: 'FILTER_ARQUEO_CAJA',
  FILTER_PAGO_CAJA: 'FILTER_PAGO_CAJA',
}

export default userConstants
